import React, { useState } from 'react'
import { motion } from 'framer-motion'
import style from './style.module.scss'
import clsx from 'clsx'
import { menuItemParams } from '../../../types'

type externalSelectProps = {
    placeholder: string
    items: menuItemParams[]
    color?: string
}

const ExternalSelect: React.FC<externalSelectProps> = ({ placeholder, items, color }) => {
    const [shown, setShown] = useState(false)

    // For close select before redirect
    const handleClick = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault()
        setShown(false)
        const target = e.currentTarget as HTMLLinkElement

        setTimeout(() => {
            if (target.target === '_blank') {
                window.open(target.href, '_blank')
            } else {
                window.location.href = target.href
            }
        }, 20)
    }

    const showMenu = {
        enter: {
            opacity: 1,
            y: 0,
            display: 'block',
        },
        exit: {
            y: -5,
            opacity: 0,
            transition: {
                duration: 0,
            },
            transitionEnd: {
                display: 'none',
            },
        },
    }

    return (
        <div className={style.instances}>
            <div
                className={clsx(style.default, shown && style.active)}
                onClick={() => setShown((prev) => !prev)}
                style={{ backgroundColor: color }}
            >
                {placeholder}
                <i className="fi fi-rs-angle-small-down"></i>
            </div>
            <motion.ul
                className={style.list}
                variants={showMenu}
                initial="exit"
                animate={shown ? 'enter' : 'exit'}
                style={{ backgroundColor: color }}
            >
                {items.map((instance) => (
                    <li key={instance.ID}>
                        <a
                            href={instance.url}
                            target={instance.target || undefined}
                            onClick={handleClick}
                        >
                            {instance.title}
                        </a>
                    </li>
                ))}
            </motion.ul>
        </div>
    )
}

export default ExternalSelect
